module.exports = __webpack_public_path__ + "static/media/bg4.6be5d8e9.webp";